import classNames from "classnames";
import { ReactNode } from "react";
import InfoCircleIcon from "../../assets/icons/info-circle.svg?react";
import { Tooltip, TooltipProps } from "./Tooltip";
import styles from "./Tooltip.module.scss";

export type InfoTooltipProps = {
  children: ReactNode;
  ariaLabel?: string;
  placement?: TooltipProps["placement"];
  className?: string;
  tooltipClassName?: string;
};

export function InfoTooltip({
  children,
  ariaLabel = "Plus d'informations",
  placement,
  className,
  tooltipClassName,
}: InfoTooltipProps) {
  return (
    <Tooltip
      placement={placement}
      className={tooltipClassName}
      renderTrigger={({ ref, isOpen, ...triggerProps }) => (
        <button
          ref={ref}
          type="button"
          aria-label={ariaLabel}
          className={classNames(styles.infoTrigger, className)}
          {...triggerProps}
        >
          <InfoCircleIcon />
        </button>
      )}
    >
      {children}
    </Tooltip>
  );
}
